<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    items?: {
      title: string
      description: string
      icon?: string
    }[]
  }>(),
  {
    title: 'Tanpa Integrasi, Operasional Pengiriman Jadi Kurang Efisien',
    items: () => [
      {
        title: 'Input Manual',
        description: 'Rawan error dan memperlambat operasional',
        icon: 'material-symbols:draw-outline'
      },
      {
        title: 'Tidak Ada Update Real Time',
        description: 'CS kewalahan menghadapi pelanggan',
        icon: 'material-symbols:alarm-outline'
      },
      {
        title: 'Pembatasan Pengiriman Masal',
        description:
          'Sulit meningkatkan skala operasional tanpa sistem terintegrasi',
        icon: 'material-symbols:local-shipping-outline'
      }
    ]
  }
)
</script>

<template>
  <UiSectionWrapper
    image-class="order-first lg:order-first"
    :title="title"
    hero-image="/images/integration-api-banner-2.webp"
    :items="items"
    class="py-12"
    :with-action="false"
  />
</template>
